// export const REACT_APP_API_BASE_CENTRALIZED_URL = process.env.REACT_APP_API_BASE_CENTRALIZED_URL as string;
export const REACT_APP_API_PLATFORM_URL = process.env.REACT_APP_API_PLATFORM_URL as string;
export const REACT_APP_API_NODE_API_URL = process.env.REACT_APP_API_NODE_API_URL as string;
export const REACT_APP_API_ORACLE_ADDRESS = process.env.REACT_APP_API_ORACLE_ADDRESS as string;
export const REACT_APP_API_DAPP_ADDRESS = process.env.REACT_APP_API_DAPP_ADDRESS as string;
